import { observer } from "mobx-react-lite";
import { FunctionComponent } from "react";

import {
  FontWeights,
  IStyle,
  mergeStyles,
  noWrap,
  Stack,
  useTheme
} from "@bps/fluent-ui";
import { AppointmentStatusCode } from "@libs/gateways/booking/BookingGateway.dtos.ts";

import { BookingCalendarEventProps } from "./BookingCalendarEvent.types.ts";
import { GroupAppointmentStatusBadge } from "./GroupAppointmentStatusBadge.tsx";

export const GroupAppointmentTitle: FunctionComponent<BookingCalendarEventProps> =
  observer(({ event }) => {
    const theme = useTheme();

    const nameStyles: IStyle = {
      ...noWrap,
      fontSize: theme.fonts.small.fontSize,
      fontWeight: FontWeights.semibold,
      flexGrow: 1
    };

    const eventTypeText =
      (event.typeRef && event.typeRef.text) || "Appointment";

    const showGroupBadge =
      event.model?.appointmentStatus === AppointmentStatusCode.Waiting ||
      event.model?.appointmentStatus === AppointmentStatusCode.Finalised;

    return (
      <Stack.Item shrink styles={{ root: { ...noWrap, paddingTop: "3px" } }}>
        <Stack horizontal verticalAlign="baseline" tokens={{ childrenGap: 8 }}>
          <span
            className={`calendar-event-name ${mergeStyles(nameStyles)}`}
            data-calendar-event-id={event.model.id}
            data-calendar-event-type={eventTypeText}
            data-calendar-create-date={event.changeLog?.createdDate}
          >
            {event.model.groupAppointmentName}
          </span>
          {showGroupBadge && <GroupAppointmentStatusBadge event={event} />}
        </Stack>
      </Stack.Item>
    );
  });
